/**
 *  Locales provided by this site
 *  https://www.oracle.com/java/technologies/javase/jdk8-jre8-suported-locales.html
 * */
const languageToLocaleMap = {
    bg: 'bg-BG',
    de: 'de-DE',
    en: 'en-GB',
    nl: 'nl-NL',
    es: 'es-ES',
};

/**
 * Retrieves the current locale based on the provided language code.
 * @param {string} language The language code to use for locale determination.
 * @returns {string} The corresponding locale code, or 'de-DE' if no match is found.
 */
export const getCurrentLocale = (language) => {
    return languageToLocaleMap[language] ?? 'de-DE';
};
